// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1dQGi","footer":"ModalCreateQualiphyProcedure_footer__mwtEq","additionData":"ModalCreateQualiphyProcedure_additionData__19DwD"};